import api from '@/api'
 

  
export default {
  createAttendance(data: any) : Promise<any>{
    return api.post({
      url: `/api/hk/attendance`,
      data : data
    });
  },

  getAttendace() : Promise<home.attendance.ResponseAttendace>{
    return api.get({
        url: `/api/hk/attendance`
      });
  },

  // 근무시간 설정 여부 확인
  getStaggerRegistCheck(personCode: string) : Promise<number>{
    return api.get({
      url: `/api/hk/stagger/StaggerRegistCheck?personCode=${personCode}`
    })
  }
}